import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DatepickerRange } from 'src/app/standalones/components/date-range-picker/date-range-picker.component';
import { DateRangePickerConstantsService } from 'src/app/services/date-range-picker-constants.service';
import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { ReportsService } from 'src/app/services/reports.service';
import { UserService } from 'src/app/services/user.service';
import { PaymentService } from 'src/app/services/payment.service';
import { BehaviorSubject, finalize, take } from 'rxjs';
import { downloadAsCSV, generateCSVFileName, ReportType } from 'src/app/reports/reports-utils';
import { BillingSessionDetails, getBillingSessionCsvFieldMap } from '../billing-usage-utils';

@UntilDestroy()
@Component({
  selector: 'app-billing-analytics-and-invoices',
  templateUrl: './billing-analytics-and-invoices.component.html',
  styleUrls: ['./billing-analytics-and-invoices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingAnalyticsAndInvoicesComponent {
  protected isLoading$ = new BehaviorSubject(false);
  selectedRange: DatepickerRange = {
    ...this.dateRangePickerConstantsService.DEFAULT_INITIAL_DATEPICKER_RANGE!,
  };
  protected readonly IconTypes = IconTypes;

  constructor(
    private reportsService: ReportsService,
    private dateRangePickerConstantsService: DateRangePickerConstantsService,
    private userService: UserService,
    private paymentService: PaymentService,
  ) {}

  datepickerRangeChange(date: DatepickerRange) {
    this.selectedRange = date;
  }

  downloadCSV() {
    this.isLoading$.next(true);
    this.reportsService
      .getBillableSessionReport({
        startDate: this.selectedRange.range.start!,
        endDate: this.selectedRange.range.end!,
      })
      .pipe(
        take(1),
        finalize(() => this.isLoading$.next(false)),
      )
      .subscribe((billingSessions) => {
        const filename = generateCSVFileName(
          ReportType.Billing,
          'Sessions-Report',
          this.selectedRange,
        );
        const enableV2Billing = this.paymentService.isV2BillingEnabled(
          this.userService.user.value?.user?.institution,
        );
        const billingSessionReportFieldsMap = getBillingSessionCsvFieldMap(enableV2Billing);
        downloadAsCSV<BillingSessionDetails>(
          filename,
          Object.values(billingSessionReportFieldsMap),
          billingSessions,
          Object.keys(billingSessionReportFieldsMap) as (keyof BillingSessionDetails)[],
        );
      });
  }
}
